import {
    InfoIcon,
    SettingsIcon,
    DrawPolygonIcon,
    BuildingIcon,
    DrawLineIcon,
    PinIcon,
    LayersIcon,
    ImportIcon,
    RulerIcon,
    ListIcon,
    PrintIcon,
    GlobeIcon,
    ViewIcon,
    EditIcon
} from '../../../components/Icon';

// Статьи
import { overviewArticle } from './articles/overview';
import { publicPartArticle } from './articles/public-part';
import { adminPartArticle } from './articles/admin-part';
import { workspacesArticle } from './articles/workspaces';
import { drawOverviewArticle } from './articles/draw-overview';
import { drawPlotsArticle } from './articles/draw-plots';
import { drawBuildingsArticle } from './articles/draw-buildings';
import { drawLinesArticle } from './articles/draw-lines';
import { drawMarkersArticle } from './articles/draw-markers';
import { basemapsArticle } from './articles/basemaps';
import { importExportArticle } from './articles/import-export';
import { measurementsArticle } from './articles/measurements';
import { legendArticle } from './articles/legend';
import { objectManagerArticle } from './articles/object-manager';
import { nspdArticle } from './articles/nspd';
import { exportPrintArticle } from './articles/export-print';
import { spdPlusArticle } from './articles/spd-plus';
import { shortcutsArticle } from './articles/shortcuts';

const SpdPlusIcon = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="12" height="12" rx="2" />
        <path d="M7 16v2a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-2" />
        <path d="M17 12h-4" />
        <path d="M15 10v4" />
    </svg>
);

const KeyboardIcon = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <path d="M6 8h.001M10 8h.001M14 8h.001M18 8h.001M6 12h.001M10 12h.001M14 12h.001M18 12h.001M7 16h10" />
    </svg>
);

export const ichisSpdRegistry = {
    title: 'Руководство пользователя',
    version: '1.2.1',
    categories: [
        {
            id: 'getting-started',
            title: 'Основы',
            items: [
                { ...overviewArticle, icon: InfoIcon },
                { ...publicPartArticle, icon: ViewIcon },
                { ...adminPartArticle, icon: EditIcon },
                { ...workspacesArticle, icon: ListIcon }
            ]
        },
        {
            id: 'shortcuts-category',
            title: 'Горячие клавиши',
            items: [
                { ...shortcutsArticle, icon: KeyboardIcon }
            ]
        },
        {
            id: 'drawing',
            title: 'Режим рисования',
            items: [
                { ...drawOverviewArticle, icon: InfoIcon },
                { ...drawPlotsArticle, icon: DrawPolygonIcon },
                { ...drawBuildingsArticle, icon: BuildingIcon },
                { ...drawLinesArticle, icon: DrawLineIcon },
                { ...drawMarkersArticle, icon: PinIcon },
                { ...basemapsArticle, icon: LayersIcon },
                { ...importExportArticle, icon: ImportIcon }
            ]
        },
        {
            id: 'data',
            title: 'Режим Данные',
            items: [
                { ...measurementsArticle, icon: RulerIcon },
                { ...legendArticle, icon: ListIcon },
                { ...objectManagerArticle, icon: SettingsIcon }
            ]
        },
        {
            id: 'modules-extended',
            title: 'Модули расширения',
            items: [
                { ...nspdArticle, icon: GlobeIcon },
                { ...exportPrintArticle, icon: PrintIcon },
                { ...spdPlusArticle, icon: SpdPlusIcon }
            ]
        }
    ]
};
